import { render, staticRenderFns } from "./VPageToolbar.vue?vue&type=template&id=76236bd0&"
import script from "./VPageToolbar.vue?vue&type=script&lang=js&"
export * from "./VPageToolbar.vue?vue&type=script&lang=js&"
import style0 from "./VPageToolbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VIcon,VToolbar})
